import { Option, none } from '@sapphire/result';
import {
  SurveyQualification,
  SurveySelectableQualification,
} from '../models/survey-qualification.model';
import { Quota } from '../models/survey-quota.model';

function isSelectableQualification(
  surveyQualification: SurveyQualification,
): surveyQualification is SurveySelectableQualification {
  return !surveyQualification.isRangeType;
}

export class SurveyQualificationInfo {
  constructor(private readonly _surveyQualification: SurveyQualification) {}

  public isSelectable(): boolean {
    return isSelectableQualification(this._surveyQualification);
  }

  public conditionCodes(): string[] {
    return isSelectableQualification(this._surveyQualification)
      ? this._surveyQualification.conditionCodes
      : [];
  }

  public rangeValue(): Option<{ min: number; max: number }> {
    if (isSelectableQualification(this._surveyQualification)) {
      return none;
    }

    const [rangeDatum] = this._surveyQualification.data;
    return Option.from(
      rangeDatum ? { min: rangeDatum.min, max: rangeDatum.max } : null,
    );
  }

  public hasQuotas(): boolean {
    return this._surveyQualification.isQuotaSet;
  }

  public hasNestedQuotas(): boolean {
    return false;
  }

  public quotas(): readonly Quota[] {
    return this._surveyQualification.quotas;
  }
}
